<div class="grid-container margin-top">
  <div class="grid-x grid-margin-x">
    <div class="cell small-12 medium-4 large-3 flex flex-align-items-center date-picker-cell">
      <label class="margin-right" for="dtpckrFromDate">From:</label>
      <common-date-picker class="flex-grow-1" [id]="'dtpckrFromDate'" [futureDateLimit]="currentDate" (dateUpdated)="fromDateChange($event)" [initialDate]="fromDate"></common-date-picker>
    </div>
    <div class="cell small-12 medium-4 large-3 flex flex-align-items-center date-picker-cell">
      <label class="margin-right" for="dtpckrToDate">To:</label>
      <common-date-picker class="flex-grow-1" [id]="'dtpckrToDate'" [pastDateLimit]="pastDateLimit" (dateUpdated)="toDateChange($event)" [initialDate]="toDate"></common-date-picker>
    </div>
    @if (displayDateWarning) {
      <span>
        {{disabledText}}
      </span>
    }
  </div>
  <!-- During enhancement 59004 we moved these buttons to the subheader -->

  <ag-grid-angular class="data-grid  fullpage" [gridOptions]="gridOptions" [rowData]="payments" (paginationChanged)="onGridPageChanged($event)" aria-label="Payment Report"></ag-grid-angular>
</div>
